import create from 'zustand'
import { AssetType } from '../constants/enum'

interface State {
  pairGroupId: number
  selectedAsset: number
  isStable: boolean
  setPairGroupId: (pairGroupId: number) => void
  selectAsset: (selectedAsset: AssetType) => void
  setIsStable: (isStable: boolean) => void
}

const useStore = create<State>(set => ({
  pairGroupId: 1,
  selectedAsset: 1,
  isStable: false,
  setPairGroupId: (pairGroupId: number) => set({ pairGroupId }),
  selectAsset: (selectedAsset: AssetType) => set({ selectedAsset }),
  setIsStable: (isStable: boolean) => set({ isStable })
}))

export default useStore
